<template>
	<div class="main">
		<div class="f_subtext f_xuzhi">
			<h2>首页</h2>
			<div class="content">
				<div class="center">
					<h1>我的游戏</h1>
					<div class="game1">
						<h3 style="font-size: 25px;">王者战舰</h3>
						<h3>游戏概述：</h3>
						<p>《王者战舰》是一款适合16岁以上玩家的宇宙战争题材游戏。游戏以卡通风格为基础，融入写实元素，让你感受到宇宙的无限广阔和刺激的战斗。</p>
						<h3>背景故事：</h3>
						<p>在遥远的未来，宇宙中的各个星系之间爆发了一场激烈的战争。你是一名年轻的飞行员，驾驶着最先进的战舰，为了保卫家园而奋战。你的任务是击落入侵的宇宙怪兽，保护星际能量源晶，以获得宇宙宝石并成为王者飞行员。
						</p>
						<h3>游戏玩法：</h3>
						<p>飞行控制：用手指触发屏幕，操控你的战舰在宇宙中飞行。躲避陨石、敌人的攻击和其他危险。</p>
						<p>击毁宇宙怪兽：利用你的武器系统，击落入侵的宇宙怪兽。每次击毁一个怪兽，你都会获得一颗宇宙宝石。</p>
						<p>能量源晶：消耗能量源晶发射子弹，保护星际能量源晶不被敌人摧毁。能量源晶是你的生命线，务必保护好它。</p>
						<h3>成就系统：</h3>
						<p>王者飞行员：击毁一定数量的宇宙怪兽，获得足够的宇宙宝石，你将被授予“王者飞行员”的荣誉称号。</p>
						<h3>准备好了吗？驾驶你的战舰，征服宇宙吧！</h3>
					</div>
				</div>
				<div class="down">
					<img v-for="(img,index) in imgs" :key="index" :src="img" />
				</div>
				<div class="xieyi">
					<span class="xieyi-child">运营单位：成都百探集信息技术有限公司</span>
					<span class="xieyi-child">审批文号：新广出审[2017]6673号</span>
					<span class="xieyi-child">游戏版号：ISBN:978-7-7979-9829-1</span>
					<span class="xieyi-child">出版单位：北京畅元国讯科技有限公司</span>
					<span class="xieyi-child">域名备案:
						<a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration:none; color: inherit;" onmouseover="this.style.color='blue'" onmouseout="this.style.color='inherit'">蜀ICP备2024076692号-2</a>
					</span>
					<span class="xieyi-child">ICP：蜀ICP备2024076692号</span>
					<span class="xieyi-child">APP备案：蜀ICP备2024076692号-5A</span>
					<span class="xieyi-child"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				corp:'custody/corp.jpg',
				imgs:[
					'custody/1.jpg',
					'custody/2.jpg',
					'custody/3.jpg',
				],
			}
		},
		created(){
			document.title="首页";
		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
	.content{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		.top{
			width: 100%;
			height: 400px;
			font-size: 50px;
			line-height: 300px;
			text-align: center;
			
		}
		.down{
			width: 100%;
			display: flex;
			justify-content: space-around;
			img{
				width: 300px;
			}
		}
		.center{
			width: 100%;
			h1{
				text-align: center;
			}
			padding-left: 20px;
			.game1{
				p{
					padding-left: 20px;
					font-size: 13px;
					font-weight: 300;
					margin-top: -10px;
					color: #419b00;
				}
			}
		}
		.xieyi{
			width: 100%;
			display: flex;
			justify-content: space-around;
			flex-wrap: wrap;
			margin-top: 50px;
			.xieyi-child{
				width: 400px;
			}
			.custom-link{
				text-decoration: none;
			}
		}
	}
	
</style>